document.addEventListener('DOMContentLoaded', function () {

  var productPersonalizer = document.querySelector('.product-personalizer');
  var productId = productPersonalizer ? productPersonalizer.dataset.id : null;

  if (!window.YH_API_ENABLED) return;
  if (!window.YH_API_BASE_URL) return;
  if (!Array.isArray(window.YH_API_PERSONALIZED_PRODUCT_IDS)) return;
  if (window.YH_API_PERSONALIZED_PRODUCT_IDS.indexOf(productId) === -1) return;
    

  var checkInterval = setInterval(function () {
    var textarea = document.querySelector('textarea.pplr_text');

    if (textarea) {
      clearInterval(checkInterval);
      startBind();
    }
  }, 2000);

  function startBind() {
    var textarea = document.querySelector('textarea.pplr_text');

    if (!textarea) return;

    // Only add button if it doesn't already exist
    if (!document.querySelector('.show-preview')) {
      var previewButton = document.createElement('a');
      previewButton.href = '#';
      previewButton.title = 'Vorschau anzeigen';
      previewButton.className = 'show-preview';
      previewButton.textContent = 'Vorschau anzeigen';
      textarea.parentNode.appendChild(previewButton);

      previewButton.addEventListener('click', handlePreviewClick);
    }
  }

  function handlePreviewClick(e) {
    e.preventDefault();

    var textarea = document.querySelector('textarea.pplr_text');
    var val = textarea ? textarea.value : '';

    console.log(`previe etxt ${val}`);
    fetch(window.YH_API_BASE_URL + '/?name=' + encodeURIComponent(val) + '&productId=' + productId + '&preview=1&multiPreview=1', {
      method: 'POST'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(function (result) {
        if (result['preview_1']) {
          setPreview(result['preview_1'], 0);
          setPreview(result['preview_2'], 1);
          setPreview(result['preview_3'], 2);

          if (window.innerWidth < 480) {
            var section = document.getElementById('shopify-section-product-template');
            if (section) {
              var targetY = section.getBoundingClientRect().top + window.pageYOffset;
              smoothScrollTo(targetY, 1000);
            }
          }
        }
      })
      .catch(function (err) {
        console.error('Preview fetch error:', err);
      })
      .finally(function () {
      });
  }

  function setPreview(previewImage, index) {
    if (!previewImage) return;

    // Get all media list items (each wraps one image/media)
    const mediaItems = document.querySelectorAll('.product__media-list .product__media-item');
    const targetItem = mediaItems[index];

    if (!targetItem) return;

    // Update the main visible image
    const img = targetItem.querySelector('img');
    if (img) {
        img.src = previewImage;
        img.srcset = previewImage;
        // Remove sizes to prevent browser picking a different srcset candidate
        img.removeAttribute('sizes');
    }

    // Dawn uses <a> tags with data-* for zoom — update those too
    const mediaLink = targetItem.querySelector('.product__media-zoom-link, a[data-zoom-src]');
    if (mediaLink) {
        mediaLink.setAttribute('data-zoom-src', previewImage);
        mediaLink.href = previewImage;
    }

    // Dawn lazy-loads via a <noscript> fallback + data-src — update those as well
    const lazyImg = targetItem.querySelector('img[data-src]');
    if (lazyImg) {
        lazyImg.setAttribute('data-src', previewImage);
        lazyImg.setAttribute('data-srcset', previewImage);
    }

    // If this is the currently active/visible slide, also update the
    // thumbnail in the media gallery nav (if Dawn's thumbnail strip is present)
    const thumbItems = document.querySelectorAll('.thumbnail-list .thumbnail-list__item');
    const targetThumb = thumbItems[index];
    if (targetThumb) {
        const thumbImg = targetThumb.querySelector('img');
        if (thumbImg) {
        thumbImg.src = previewImage;
        thumbImg.srcset = previewImage;
        }
    }

    
  }

  // Smooth scroll polyfill (replaces jQuery animate scrollTop)
  function smoothScrollTo(targetY, duration) {
    var startY = window.pageYOffset;
    var diff = targetY - startY;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      // Ease in-out
      var ease = progress < 0.5
        ? 2 * progress * progress
        : -1 + (4 - 2 * progress) * progress;

      window.scrollTo(0, startY + diff * ease);

      if (elapsed < duration) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

});